import { TIER_TYPE_VALUES, TierType } from '../types/apiTypes';

/**
 * Narrows a stored `selected_tier` string to a real `TierType`.
 *
 * `selected_tier` is persisted as a bare string, so a value that predates a tier being
 * removed — or was never valid — must read as "no pick" rather than being indexed blindly
 * into tier config.
 *
 * Lives here, not in `types/apiTypes.ts`, because that file is GENERATED from the backend
 * (`type-utils`). This helper has no backend source, so every regeneration deleted it and
 * broke the build; the enum and value list it leans on are generated and imported above.
 */
export const asTierType = (value: string | undefined): TierType | null =>
  value && TIER_TYPE_VALUES.includes(value as TierType)
    ? (value as TierType)
    : null;
